import { gql } from '@apollo/client';

export default class PayrollGeneralMutation {
    static ADD_DAILY_ACTION_LOG = gql`
        mutation AddDailyActionLog($input: AddDailyActionLogInput!) {
            addDailyActionLog(input: $input)
        }
    `;

    static UPDATE_USER_QUICK_NOTE = gql`
        mutation updateUserQuickNote($userId: Int!, $quickNote: String!) {
            updateUserQuickNote(userId: $userId, quickNote: $quickNote)
        }
    `;

    static CLEAR_DRAW_BALANCE = gql`
        mutation clearDrawBalance($employeeId: Int!) {
            clearDrawBalance(employeeId: $employeeId)
        }
    `;
}
